import * as React from 'react';
import { useShouldRenderBlueprint } from '../../useShouldRenderBlueprint';
import VariantComponent from '../../variant-component';
import BlueprintUploadField from './blueprint-upload-field';
import BuieUploadField from './buie-upload-field';
import type { UploadFieldProps } from './types';

const VariantUploadField = (props: UploadFieldProps) => {
  // Should be addressed in FORMS-21209
  const shouldRenderBlueprint = useShouldRenderBlueprint();

  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintUploadField}
      OldComponent={BuieUploadField}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default VariantUploadField;
